import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { CustomToastService } from './custom-toast.service';

@Injectable({
    providedIn: 'root',
})
export class CustomValidatorService {
    constructor(private customToastService: CustomToastService) {}

    noSpecialCharsValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value;
            if (value === null || value === undefined || typeof value !== 'string') return null;
            const regex = /^[a-zA-Z0-9\s]*$/; // letters, numbers, spaces only
            return regex.test(value) ? null : { specialCharsNotAllowed: true };
        };
    }

    noSpecialCharsAllowUnderscoreHypenValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value;
            if (value === null || value === undefined || typeof value !== 'string') return null;
            const regex = /^[a-zA-Z0-9_\-\s]*$/; // letters, numbers, spaces only,underscore
            return regex.test(value) ? null : { specialCharsNotAllowed: true };
        };
    }

    validateKeyPress(event: KeyboardEvent | ClipboardEvent, typeOfValidation?: string): void {
        if (typeOfValidation === 'NumericNoSpace') {
            if (event.type === 'paste') {
                const pastedText = (event as ClipboardEvent).clipboardData?.getData('text') || '';
                if (/[^0-9]/.test(pastedText) || pastedText.includes(' ')) {
                    event.preventDefault();
                    this.customToastService.errorToast('Only numeric characters are allowed.');
                }
                return;
            }

            const keyEvent = event as KeyboardEvent;
            const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Enter', 'Escape', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
            if (allowedKeys.includes(keyEvent.key)) {
                return;
            }

            if (keyEvent.key === ' ' || /[^0-9]/.test(keyEvent.key)) {
                keyEvent.preventDefault();
                return;
            }

            return;
        }

        // Check Sql injection for paste
        if (event.type === 'paste') {
            const pastedText = (event as ClipboardEvent).clipboardData?.getData('text') || '';
            const detectedIssues = this.avoidSqlInjection(pastedText);
            if (detectedIssues?.length || detectedIssues.length > 0) {
                event.preventDefault();
                this.customToastService.errorToast('Input contains invalid characters.');
            }

            return;
        }

        // Check Sql injection
        const inputElement = event.target as HTMLInputElement;
        const currentValue = inputElement.value;
        const detectedIssues = this.avoidSqlInjection(currentValue);

        if (detectedIssues.length > 0) {
            event.preventDefault();
            this.customToastService.errorToast('Input contains invalid characters.');
        }
    }

    validateSqlInjectionforDevExpress(value: string) {
        let ret: boolean = true;
        const detectedIssues = this.avoidSqlInjection(value);
        if (detectedIssues.length > 0) {
            this.customToastService.errorToast('Input contains invalid characters.');
            ret = false;
        }
        return ret;
    }

    avoidSqlInjection(input: string): string[] {
        let pattern: { pattern: RegExp; description: string }[] = [
            { pattern: /(SELECT|INSERT|UPDATE|DELETE|DROP|EXEC|UNION).*(FROM|WHERE)/i, description: 'Potential SQL Injection' },
            { pattern: /<script>/i, description: 'Potential XSS' },
            { pattern: /(&&|;\|\|)/, description: 'Potential Command Injection' },
            { pattern: /javascript:/i, description: 'Potential XSS via URL' },
        ];

        const issues: string[] = [];
        for (const entry of pattern) {
            if (entry.pattern.test(input)) {
                issues.push(entry.description);
            }
        }
        return issues;
    }
}
